export default function (axios) {
  return {
    // 查询测验详情
    getProjectEdit(params) {
      return axios.get("/projectBase/selectProject", { params });
    },
    //问卷信息
    selectPaperByPaperIdNose(params) {
      return axios.get("/paperCtl/selectPaperByPaperIdNose", { params });
    },

    //详情页问卷列表
    getProScorePaperListReq(params) {
      return axios.get("/project/score/selectPaperList", { params });
    },
    //获取考生监控记录
    selectMonitorRecordReq(params) {
      return axios.post("/anon/projectInvigilate/selectMonitorRecord", params);
    },
    //详情
    getScoreDetailReq(params) {
      return axios.get("/project/score/selectScoreDetail", { params });
    },
    //查询单个考生
    getInvigilateByIdReq(params) {
      return axios.get("/project/data/selectInvigilateByStudentId", { params });
    },
    //项目成绩-导出报告
    exportProjectReportReq(params) {
      return axios.get("/fileMake/exportProjectReport", { params });
    },
    //获取导出报告的url
    getProjectReportReq(params) {
      return axios.get("/fileMake/getExportUrl", { params });
    },
  };
}
